import styled from 'styled-components';

import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $Wrapper = styled.div`
  margin-top: ${spacing(12)};
`;

export const $Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 ${spacing(1.5)};
`;

export const $FileHeader = styled.div`
  flex: 1;
  font-size: ${({ theme }) => theme.fonts.size.large};
  margin-bottom: ${spacing('sm')};
  color: ${({ theme }) => theme.newUI.defaultColors.heading};
`;

export const $CollapsableButton = styled.div`
  display: flex;
  align-items: center;
  z-index: 1;
  cursor: pointer;
`;

export const $TrackingLink = styled.a`
  color: ${({ theme }) => theme.colors.primary};
  text-decoration: underline;
`;
